module.exports = __webpack_public_path__ + "img/register-hospital-bg.68da7c59.jpg";